import React, { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap'
import CustomButton from './CustomButton'
import { Gradient } from "./../gradient";

const Banner = () => {
  const navigate = useNavigate();
  useEffect(() => {
    // Initialize the gradient after the component mounts
    const gradient = new Gradient();
    gradient.initGradient("#gradient-canvas");
  }, []);
  return (
    <>
    {/* <div className="voloto-banner" >
    
      <canvas
        id="gradient-canvas"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          "--gradient-color-1": "#010639",
          "--gradient-color-2": "#9F2FA9",
          "--gradient-color-3": "#320045",
        }}
      />

      <div className="container position-relative h-85" >
      <Row className='h-100'>
          <Col lg={12} className='h-100 d-flex align-items-center'>
          <div className='volto-banner-header'>
            <h1>Turning Challenges</h1>
            <h3>Into Opportunities</h3>
          
            <p className='mt-4'>Where others see complexity,</p>
            <p className='mb-5 volto-margin'>Volto  envisions innovation and transformation.</p>
            <div className='mt-5 volto-banner-btn-home'><CustomButton buttonText='Let’s Connect' buttonType='bannerBtn' onClick={() => navigate("./contact")} arrow /></div>
            
            </div>
          </Col>
        </Row>
        <div className="">
          
          <style>
            {`
              @keyframes colorCycle {
                0% {
                  color: black;
                }
                25% {
                  color: black;
                }
                50% {
                  color: white;
                }
                75% {
                  color: white;
                }
                100% {
                  color: black;
                }
              }
              .color-animate {
                animation: colorCycle 4s linear infinite;
              }
            `}
          </style>
         
        </div>
      </div>
      
    </div> */}

     <div className="voloto-banner speed-banner" style={{backgroundImage: "url('/images/turning-bg.webp'), linear-gradient(#f0f0f0, #ccc)"}}>
        
          <div className="container position-relative h-85" >
          <Row className='h-100'>
              <Col lg={12} className='h-100 d-flex align-items-center'>
              <div className='volto-banner-header'>
                <h1 className='banner-two-text'>Turning Challenges</h1>
                <h3 className='banner-three-sub-head'>Into Opportunities</h3>
              
                {/* <p className='mt-4 mb-5 volto-margin '>
                  Comprehensive, end-to-end support <br /> to build and scale your GCC seamlessly.
                  

                   
                   </p> */}
                   <p className='mt-4'>Where others see complexity,</p>
            <p className='mb-5 volto-margin'>Volto  envisions innovation and transformation.</p>
                
                <div className='mt-5 volto-banner-btn-home'><CustomButton buttonText='Let’s Connect' buttonType='bannerBtn' onClick={() => navigate("/contact")} arrow /></div>
                
                </div>
              </Col>
            </Row>
            <div className="">
              {/* Style tag for inline keyframes */}
              <style>
                {`
                  @keyframes colorCycle {
                    0% {
                      color: black;
                    }
                    25% {
                      color: black;
                    }
                    50% {
                      color: white;
                    }
                    75% {
                      color: white;
                    }
                    100% {
                      color: black;
                    }
                  }
                  .color-animate {
                    animation: colorCycle 4s linear infinite;
                  }
                `}
              </style>
             
            </div>
          </div>
          
        </div>


    </>

    
  )
}

export default Banner
